<script>
import {useToast} from "vue-toastification";
import UserSelectDialog from "@/UserSelectDialog.vue";
import assetMaterialsHelper from "@/mixins/assetMaterialsHelper";

export default {
  components: {
    UserSelectDialog
  },
  mixins: [
    assetMaterialsHelper
  ],
  props: [
      'client_id',
      'drupal_input_id', // The ID of hidden input element where we will add all ID's of selected user(s)
      'user_cardinality', // Can be '-1' for unlimited users or, for example '1' if you only want to select one user
      'user_empty_text', // Shown when the no users are selected
  ],
  async mounted() {
    // Setup toast
    this.toast = useToast()
    // Get CSRF token
    await this.requestGetCSRFtoken();
    // Check if drupal_input_id already has a value
    const element = this.drupalInputElement();
    if (element !== null && element.value) {
      // Split string values into a array
      const uids = element.value.split(",");
      // Load all users
      for (const uid of uids) {
        // Load the user from the server
        let user = await this.requestLoadDatabase(uid);
        // Add user to the user list
        this.addUser(user);
      }
    }
  },
  data () {
    return {
      toast: null,
      users: [],
      selectUserDialog: false,
    }
  },
  computed: {

  },
  watch: {
    users: {
      handler(newValue) {
        const element = this.drupalInputElement();
        if (element === null) {
          return;
        }
        // Get all ID's
        const ids = [];
        for (const user of newValue) {
          ids.push(user.uid);
        }
        // Create string from all ID's
        const ids_joined = ids.join(',');
        // Set value in the Drupal DOM input element
        element.value = ids_joined;
      },
      deep: true
    },
  },
  methods: {
    openUserDialog() {
      this.selectUserDialog = true;
    },
    closeUserDialog() {
      this.selectUserDialog = false;
    },
    userSelected(selected_user) {
      const user = selected_user.selected_user;
      // Add the user
      this.addUser(user);
      // Close the dialog
      this.closeUserDialog();
    },
    addUser(user) {
      this.users.push(user);
      this.$emit('user-added', user);
    },
    removeUser(index) {
      this.users.splice(index, 1);
      this.$emit('user-remove', index);
    },
    drupalInputElement() {
      if (!this.drupal_input_id) {
        return null;
      }
      // Get the Drupal DOM input element
      const element_id = "#"+this.drupal_input_id;
      const element = document.querySelector(element_id);
      return element;
    },
    async requestLoadDatabase(uid) {
      const response = await fetch(import.meta.env.VITE_API_BASEURL + 'api/user/' + uid, {
        credentials: "include",
        headers: this.requestHeaders,
      })
      let database = await response.json();
      return database;
    }
  },
}
</script>


<template>
  <v-table v-if="users.length" class="user-table">
    <thead>
    <tr>
      <th class="text-left">
        Gebruiker
      </th>
    </tr>
    </thead>
    <tbody>
    <tr
      v-for="(user, index) in users"
      :key="user.uid"
    >
      <td>{{ user.name }}</td>
      <td>{{ user.roles }}</td>
      <td>
        <v-btn
          color="error"
          @click="removeUser(index)"
        >
          Verwijder
        </v-btn>
      </td>
    </tr>
    </tbody>
  </v-table>
  <p v-else>
    {{ user_empty_text }}
  </p>

  <v-btn
    color="primary"
    class="mt-2"
    @click="openUserDialog()"
    v-if="users.length < user_cardinality || user_cardinality === -1"
  >
    Selecteer gebruiker
  </v-btn>

  <!-- Select user dialog -->
  <user-select-dialog
    v-model="selectUserDialog"
    @user-selected="userSelected"
    @dialog-closed="closeUserDialog"
  ></user-select-dialog>


</template>

<style lang="scss">
  .user-table {
    table {
      margin: 0;
    }
  }
</style>
